const v31 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        freelancersTable: {
          ...state.options.tableViews.freelancersTable,
          'Start Date': true,
        },
      },
    },
  };
};

export default v31;
